/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Firebase from 'firebase/app';

import { withInstance } from 'fierry/react';

import Status from 'solis/auth/enum';

import 'global/auth';


// Must change both client and server OFFLINE flags.
export const OFFLINE = true;


const Auth = withInstance(class
{
  constructor ()
  {
    this.token = null;
    this.status = Status.Pending;

    this.unsubscribe = null;
    this.listeners = new Set();
  }


  connect ()
  {
    if (!OFFLINE)
    {
      this.unsubscribe = Firebase.auth().onIdTokenChanged(this.onUserChanged);
    }
  }


  disconnect ()
  {
    if (!OFFLINE && this.unsubscribe)
    {
      this.unsubscribe();
    }
  }


  setOfflineUser (userIdx)
  {
    const offlineToken = `offline/${userIdx}`;

    if (!OFFLINE || this.token?.offlineToken === offlineToken)
    {
      return;
    }

    this.setState({ status: Status.Active, token: { offlineToken } });
  }


  subscribe (listener)
  {
    this.listeners.add(listener);

    return () => this.listeners.delete(listener);
  }


  setState (state)
  {
    Object.assign(this, state);

    this.notify();
  }


  notify ()
  {
    for (const listener of this.listeners)
    {
      listener();
    }
  }


  signOut ()
  {
    return Firebase.auth().signOut();
  }


  onUserChanged = (user) =>
  {
    if (user)
    {
      this.setState({ status: Status.Active });

      user.getIdToken().then((token) =>
      {
        this.setState({ token: { firebaseToken: token } });
      });
    }
    else
    {
      this.setState({ status: Status.SignedOut, token: null });
    }
  }


});


Object.assign(Auth, Status);


export default Auth;
